<template>
    <div class="position-relative">
        <textarea 
            class="form-control w-100 test-text-area-with-audio" 
            :disabled="disabledAttr" 
            :id="idAttr" 
            v-model="content"
            :placeholder="placeholderAttr" 
            :rows="rows" 
            :max-rows="maxRows" 
            :resize="true"
        >
    </textarea>
    <div class="position-absolute" id="audio-container">

        <b-button class="test-start-recording-btn" variant="info" size="sm" v-if="!isRecording" @click="startRecording" v-b-tooltip.hover.left="$translate('start_recording')" :disabled="disabledAttr"><i class="fa fa-microphone"></i> </b-button>
        <b-button  variant="info" size="sm" v-else @click="stopRecording" v-b-tooltip.hover.left="$translate('stop_recording')" :disabled="disabledAttr" class="recording test-stop-recording-btn"><i class="fa fa-pause"></i></b-button>
        <!-- <b-button variant="info" size="sm" v-if="!isRecording" @click="startRecording" :disabled="disabledAttr">{{ $translate('start_recording') }} </b-button>

        <b-button variant="info" size="sm" v-else @click="stopRecording" class="recording" :disabled="disabledAttr"> {{ $translate('stop_recording') }}</b-button> -->
    </div>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'textarea-with-audio',
    props: [
        'idAttr',
        'disabledAttr',
        'placeholderAttr',
        'rows',
        'maxRows',
        'value',
    
    ],
    data() {
        return {
            isRecording: false,
            mediaRecorder: null,
            audioChunks: [],
            transcription: '',
            contentValue: this.value,
            content: '',
            
        }
    },
    created() { },
    computed: {
        // content: {
        //     // getter
        //     get() {
        //         console.log('...........', this.value)
        //         // return this.value
        //         return this.contentValue;
        //     },
        //     // setter
        //     set(val) {
        //         this.contentValue = val
        //         this.$emit('update:content', val)
        //     },
        // }
    },
    watch: {
        content: function(val) {
            this.$emit('input', val);
        }
    },
    mounted(){
       if (this.value) {
            this.content = this.value;
            this.transcription = this.value;
       }
    },
    methods: {
        async startRecording() {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                alert('Media Devices will not work on your browser.');
                return;
            }

            try {
                const stream = await this.requestMicrophoneAccess()
                if(!stream) return false;
                this.mediaRecorder = new MediaRecorder(stream);
                this.audioChunks = [];

                this.mediaRecorder.ondataavailable = e => {
                this.audioChunks.push(e.data);
                };

                // Stop recording after 59 seconds
                setTimeout(() => {
                    if (this.isRecording) {
                        this.stopRecording();
                    }
                }, 40000);


                this.mediaRecorder.start();
                this.isRecording = true;
            } catch (error) {
                console.error('Error accessing microphone:', error);
            }
        },

        stopRecording() {
            if (this.mediaRecorder) {
                this.mediaRecorder.stop();
                this.mediaRecorder.onstop = async () => {
                const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
                this.transcribeAudio(audioBlob);
                this.isRecording = false;
                };
            }
        },

        async transcribeAudio(blob) {
            const formData = new FormData();
            formData.append("file", blob, "recording.webm");

            try {
                const response = await axios.post('auth/transcribe', formData);

                const data = response.data.success.data;
                // console.log('data',data);

                // Append new transcription data to existing content
                if(this.transcription == ''){
                    this.transcription = data.transcription;
                } else {
                    this.transcription = ', ' + data.transcription;
                }
                // console.log('this.transcription',this.transcription);
                this.content += this.transcription; // Update content
                // this.$emit('update:content',  this.contentValue )
            } catch (error) {
                console.error('Error transcribing audio:', error);
            }
        },
        async requestMicrophoneAccess() {
            try {
                // Check if the browser supports getUserMedia
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    // Try to access the microphone
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    // Microphone access granted, you can use the stream now
                    console.log('Microphone access granted');
                    return stream;
                } else {
                    // Browser doesn't support getUserMedia
                    throw new Error('Your browser does not support microphone access.');
                }
            } catch (err) {
                // Microphone access denied or error occurred
                console.error('Error accessing microphone:', err);
                if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                    // User denied permission, show a message or prompt to enable microphone access
                    alert('Please allow microphone access to use this feature.');
                } else {
                    // Other error occurred, handle accordingly
                    alert('An error occurred while accessing the microphone.');
                }
            }
        },
    },
}
</script>
<style scoped>
#audio-container{
    right: 8px;
    bottom: 9px;
}
.recording {
    color: white;
    background-color: #0085FF; /* Change the background color to indicate recording */
    animation: pulse 1s infinite alternate; /* Apply a pulsating animation */
}

@keyframes pulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}
</style>